// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import { isMobile } from "./isMobile";
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  EffectCreative,
} from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Mousewheel, EffectCreative]);

/*
 *
 * ----------------------------------------------- */
var swiperWorks = document.querySelector(".swiper-works");

if (swiperWorks) {
  var swiperWorksElement = new Swiper(swiperWorks, {
    slidesPerView: "1",
    centeredSlides: true,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-works-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-works-button-next",
      prevEl: ".swiper-works-button-prev",
    },
    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 80,
        mousewheel: {
          releaseOnEdges: true,
          eventsTarget: ".section-works .sticky-wrapper",
        },
      },
    },
    speed: 600,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: [0, 0, -400],
        scale: 0.1,
      },
      next: {
        translate: ["calc(100% + 80px)", 0, 0],
      },
    },
  });
}

$(window).on("load resize", function () {
  var $stickyWrapper = $(".section-works .sticky-wrapper");

  var windowHeight = $(window).height();
  var scrollPos = 0;

  var distFromTop = $stickyWrapper.offset().top;
  var scrollDistance = distFromTop + windowHeight;

  if (isMobile()) {
    var $sectionWorks = $(".section-works");
    var sectionWorksHeight = $sectionWorks.height();
    distFromTop = $stickyWrapper.offset().top - sectionWorksHeight;
    scrollDistance = distFromTop + windowHeight;
  }

  $(document).scroll(function () {
    scrollPos = $(this).scrollTop();

    if (scrollPos >= distFromTop && scrollPos <= scrollDistance) {
      $stickyWrapper.addClass("active");
    } else {
      $stickyWrapper.removeClass("active");
    }

    if (!isMobile()) {
      if ($stickyWrapper.hasClass("active")) {
        swiperWorksElement.mousewheel.enable();
        swiperWorksElement.update();
      } else {
        swiperWorksElement.mousewheel.disable();
        swiperWorksElement.update();
      }
    }

    if (scrollPos >= distFromTop) {
      $("body").addClass("active");
    } else {
      $("body").removeClass("active");
    }
  });
});
